module.exports = __webpack_public_path__ + "static/media/device-voltage.5a828162.svg";